export default __webpack_public_path__ + "img/87e4d95e061cde6956a4878f2a623f78.png";